<template>
  <div>
    <page-header>
      <div slot="content">
        <header-title link="/team" title="Team"></header-title>
      </div>
    </page-header>
    <div class="body">
      <h1 id="summary" class="">Our team is the all-star team of all-star teams. At least we think so. We value individuality in order to maximize different ways to approach a project. Our team brings a vast array of experience from various fields in order to create the best web, mobile, and game products we can.</h1>
    </div>
    <div id="sub-sections">
      <div id="team" class="sub-section">
        <div v-if="teammates.length" class="grid">
          <teammate v-for="(teammate, index) in teammates" 
            :key="index" 
            :teammate="teammate" 
            :github-username="teammate.github_username">
          </teammate>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
import DataStore from '@/storage/data'
import HeaderTitle from '@/components/HeaderTitle'
import PageHeader from '@/components/PageHeader'
import Teammate from './Teammate'
export default {
  name: 'team',
  props: {
    scrollPosition: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      teammates: DataStore.teammates
    }
  },
  components: {
    HeaderTitle,
    PageHeader,
    Teammate
  }
}
</script>



// WEBPACK FOOTER //
// Team.vue?f8592d0a